import { Injectable } from '@angular/core';
import { Column, ColumnType } from '../../../../SGRE-shared/models/tableConfiguration';
import { OrderRequestConstants } from '../../model/order-request.model';
import { OrderRequestDetails, OrderRequestPage, Result, } from '../order-requet.state';
import { LegalEntity } from '../../../../SGRE-shared/models/legalEntityList.model';

@Injectable({
    providedIn: 'root'
})
export class OrderRequestEffectsService {

    formatOrderRequestData(data: OrderRequestPage): OrderRequestDetails {
        const formattedData = data?.results?.map(item => this.mapData(item));
        const updatedData = this.createTableConfiguration(formattedData);
        return updatedData;
    }

    mapData(orderRequestData: Result): Result {
        orderRequestData.legalEntity = (orderRequestData?.legalEntity as LegalEntity)?.name;
        orderRequestData.orderRequestedBy = orderRequestData?.requestedBy ? orderRequestData?.requestedBy.split('|')[1] : '';
        orderRequestData.productsCount = orderRequestData?.lineItemCount;
        orderRequestData.totalPrice = orderRequestData?.orderTotal;
        orderRequestData.requestDate = orderRequestData?.orderDate;
        orderRequestData.status = OrderRequestConstants.EDIT;
        return orderRequestData;
    }

    createTableConfiguration(data: Result[]): OrderRequestDetails {
        const filterLegalEnties = this.getFilterData(data, OrderRequestConstants.LEGAL_ENTITY);
        const filterRequestedBy = this.getFilterData(data, OrderRequestConstants.ORDER_REQUESTED_BY);
        const filterProductCount = this.getFilterData(data, OrderRequestConstants.LINE_ITEM_COUNT);
        const columnData = [
            {
                label: OrderRequestConstants.LEGAL_ENTITY_LABEL, name: OrderRequestConstants.LEGAL_ENTITY, type: ColumnType.text,
                filter: true, filterOptions: (filterLegalEnties).map((item) => ({ legalEntity: item }))
            },
            {
                label: OrderRequestConstants.REQUESTED_BY_LABEL, name: OrderRequestConstants.ORDER_REQUESTED_BY, type: ColumnType.text,
                filter: true, filterOptions: (filterRequestedBy).map((item) => ({ orderRequestedBy: item }))
            },
            {
                label: OrderRequestConstants.PRODUCT_COUNT_LABEL, name: OrderRequestConstants.PRODUCT_COUNT, type: ColumnType.number,
                filter: true, filterOptions: (filterProductCount).map((item) => ({ productsCount: item }))
            },
            { label: OrderRequestConstants.TOTAL_COST, name: OrderRequestConstants.TOTAL_PRICE, type: ColumnType.price },
            { label: OrderRequestConstants.REQUESTED_ON, name: OrderRequestConstants.REQUEST_DATE, type: ColumnType.date },
            { label: OrderRequestConstants.ACTION_LABEL, name: OrderRequestConstants.ACTION, type: ColumnType.info },
        ];
        const orderRequestHeader = columnData.map(item => new Column(item));
        return { orderRequest: data, orderRequestHeader };

    }

    getFilterData(tableData: Result[], filterKey: string): string[] {
        const filteredArray = tableData?.filter((item) => {
            return item[filterKey] !== undefined
        }).map((c) => c[filterKey]);
        return Array.from(new Set(filteredArray));
    }
}
